import { getFunctionalPartitioningDictionary, getPurchaserCategoryDictionary } from '@/utils/api'

export default {
  state: {
    medicalCategoryTypeList: [
      { id: 13, dictionaryName: '医疗行业细分市场' },
      { id: 14, dictionaryName: '医院系统细分市场' },
    ],
    medicalCategoryTypeIdList1: [],
    medicalCategoryTypeIdList2: [],
    medicalEditCategoryList: []
  },
  getters: {},
  mutations: {
    setMedicalCategoryTypeIdList1(state, data) {
      state.medicalCategoryTypeIdList1 = data
    },
    setMedicalCategoryTypeIdList2(state, data) {
      state.medicalCategoryTypeIdList2 = data
    },
    setMedicalEditCategoryList(state, data) {
      state.medicalEditCategoryList = data
    }
  },
  actions: {
    // 获取照明类别
    async getMedicalCategoryTypeIdList1({ commit }) {
      let [err, res] = await getFunctionalPartitioningDictionary(13)
      if (err) return
      commit('setMedicalCategoryTypeIdList1', res)
    },
    async getMedicalCategoryTypeIdList2({ commit }) {
      let [err, res] = await getFunctionalPartitioningDictionary(14)
      if (err) return
      commit('setMedicalCategoryTypeIdList2', res)
    },
    async getMedicalEditCategoryList({ commit }) {
      let [err, res] = await getPurchaserCategoryDictionary(10)
      if (err) return
      commit('setMedicalEditCategoryList', res)
    }
  }
}